import React from 'react'
import { SimpleSpinner } from './SimpleSpinner'

export const Card = ({ children, className, top }) => {
  const classes = className ? `card ${className}` : `card`

  return (
    <div style={{ top: top, transition: 'top ease 500ms' }} className={classes}>
      {children}
    </div>
  )
}

export const SpinnerCard = ({ spinnerActive, children, className, top }) => (
  <Card className={className} top={top}>
    {spinnerActive ? <SimpleSpinner /> : children}
  </Card>
)

export const Article = ({ children }) => (
  <article className="article">{children}</article>
)

export const ArticleLarge = ({ children }) => (
  <article className="article-lg">{children}</article>
)

export const Segment = ({ children }) => (
  <section className="segment">{children}</section>
)

export const Panel = ({ children }) => (
  <section className="panel">{children}</section>
)

export const Nav = ({ children }) => <nav className="nav">{children}</nav>

export const Sidebar = ({ children }) => (
  <aside className="aside">{children}</aside>
)

export default {
  Article,
  ArticleLarge,
  Card,
  SpinnerCard,
  Nav,
  Sidebar,
  Segment,
  Panel
}
